export default __webpack_public_path__ + "img/04fd0a7d1bf4d5a38088ca94c62c0e3f.png";